import translate from 'angular-translate';

export default angular.module('eventix.common.services.errorRejector', [translate])
/**
 * @ngdoc service
 * @name eventix.common.services.ErrorRejector
 * @description
 * Handle errors
 *
 * Sends a (translated) message to UIMessages
 * Sends an error to console
 * Returns a rejected promise
 *
 */

/**
 * @ngdoc service
 * @name eventix.common.services.ErrorRejectorProvider
 * @description
 * Handle errors
 *
 * Sends a (translated) message to UIMessages
 * Sends an error to console
 * Returns a rejected promise
 */
    .provider('ErrorRejector', function() {
        this.$get = /*@ngInject*/function($q, UIMessages) { // $translate, $timeout, $window
            let ErrorRejector = {};

            /**
             * @ngdoc method
             * @name eventix.common.services.ErrorRejector#handle
             * @methodOf eventix.common.services.ErrorRejector
             * @description
             * Handle an error
             *
             * @param {Object|String} error The error to handle
             * @example
             * <pre>
             * ErrorRejector.handle('Some error message');
             * ErrorRejector.handle(response.error);
             * </pre>
             */
            Object.defineProperty(ErrorRejector, 'handle', {
                configurable: false,
                writable: false,
                enumerable: false,
                value: function(error, ...context) {
                    let messageString = null;

                    if (_.isString(error)) {
                        messageString = error;
                    } else if (_.has(error, 'message') && _.isString(error.message)) {
                        messageString = error.message;
                    } else if (_.has(error, 'data.error_description') && _.isString(error.data.error_description)) {
                        messageString = error.data.error_description;
                    } else if (_.has(error, 'error_description') && _.isString(error.error_description)) {
                        messageString = error.error_description;
                    } else if (_.has(error, 'data.errors') && _.isArray(error.data.errors)) {
                        if (_.every(error.data.errors, error => _.isString(error))) {
                            messageString = _.join(error.data.errors, '\n');
                        } else if (_.every(error.data.errors, error => _.has(error, 'reason'))) {
                            messageString = _.join(_.map(error.data.errors, 'reason'), '\n');
                        }
                    } else if (_.has(error, 'errors') && _.isArray(error.errors) && _.every(error.errors, error => _.isString(error))) {
                        if (_.every(error.errors, error => _.isString(error))) {
                            messageString = _.join(error.errors, '\n');
                        } else if (_.every(error.errors, error => _.has(error, 'reason'))) {
                            messageString = _.join(_.map(error.errors, 'reason'), '\n');
                        }
                    } else if (_.has(error, 'data') && _.isString(error.data)) {
                        messageString = error.data;
                    }

                    if (_.isNil(messageString)) {
                        messageString = 'Unknown error';
                    }

                    console.error.apply(null, messageString === error ? [messageString, ...context] : [messageString, error, ...context]);

                    UIMessages.push({type: 'error', message: messageString});

                    return $q.reject(messageString);
                }
            });

            return ErrorRejector;
        };

    }).name;
